import { render, staticRenderFns } from "./RenShi3.vue?vue&type=template&id=903b38ea&scoped=true&"
import script from "./RenShi3.vue?vue&type=script&lang=js&"
export * from "./RenShi3.vue?vue&type=script&lang=js&"
import style0 from "./RenShi3.vue?vue&type=style&index=0&id=903b38ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903b38ea",
  null
  
)

export default component.exports